/* "Need help?" window: open/close only - all its content is rendered
   server-side in sections/header.liquid, so unlike the ajax cart drawer
   there is nothing to fetch here. */
(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var modal = document.querySelector('[data-help-modal]');
    if (!modal) return;

    var lastFocused = null;

    function isOpen() {
      return !modal.hidden;
    }

    function closeOtherOverlays() {
      var cartDrawer = document.querySelector('[data-cart-drawer]');
      if (cartDrawer && !cartDrawer.hidden) cartDrawer.hidden = true;
    }

    function openModal() {
      closeOtherOverlays();
      lastFocused = document.activeElement;
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
      var closeBtn = modal.querySelector('.help-modal__close');
      if (closeBtn) closeBtn.focus();
    }

    function closeModal() {
      if (modal.hidden) return;
      modal.hidden = true;
      document.body.style.overflow = '';
      if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
    }

    document.addEventListener('click', function (event) {
      var target = event.target;
      if (!target.closest) return;

      var trigger = target.closest('[data-help-trigger]');
      if (trigger) {
        event.preventDefault();
        openModal();
        return;
      }

      if (target.closest('[data-help-modal-close]')) {
        event.preventDefault();
        closeModal();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (!isOpen()) return;

      if (event.key === 'Escape') {
        closeModal();
        return;
      }

      if (event.key === 'Tab') {
        var focusable = modal.querySelectorAll('a[href], button:not([disabled])');
        if (!focusable.length) return;
        var first = focusable[0];
        var last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }
    });
  });
})();
